import { Box, Stack, Typography } from '@mui/material'
import { memo } from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import { CustomTokenInfo } from '@/utils/helpers'

type ViewProps = {
  onClickToken: (token: CustomTokenInfo) => void
  tokensList: CustomTokenInfo[]
}

const View = ({ onClickToken, tokensList }: ViewProps) => {
  return (
    <Stack direction="row" gap={2} flexWrap="wrap" data-testid="quick-tokens-action">
      {
        tokensList.map(token => (
          <Box
            key={token.symbol}
            display="flex" alignItems="center" flexDirection="row" gap="6px"
            className="bg-[#141A23] py-2 px-[12px] rounded-[10px] cursor-pointer hover:bg-[#1A2330]/70"
            onClick={() => onClickToken(token)}
            data-testid={`quick-token-action-${token.symbol}`}
          >
            <LazyLoadImage
              src={token.logoURI}
              alt={token.symbol}
              width="24px"
              height="24px"
            />
            <Typography className="text-sm font-semibold text-white">{token.displaySymbol}</Typography>
          </Box>
        ))
      }
    </Stack>
  )
}

export default memo(View)
